import React from 'react';
import error500 from '../../../../assets/img/Errors/500-error.png';
import './server-page.scss';

import ErrorPage from '../../../../components/error-pages/error'

// for errors in any render methods (displays as a '500' error page)
const ServerPage = (props) => {
    const refresh = <span className="server-refresh" onClick={() => window.location.reload()}>refresh</span>;
    const title = "Triyo - 500 Error";
    const image = <img className="server-picture" src={error500} alt={"500 Error"} />;
    const header = <h4 className="server-title" style={{ fontWeight: 'bolder' }}> Internal Server Error </h4>;
    const info =
        <>
            <h4 className="server-title">{props.detail}</h4>
            <p className="server-info">Sorry, this is unexpected! We are doing our best to fix the problem. <br></br> Please {refresh} the page or check back later.</p>
        </>
    const buttonText = "Go to Task Page";

    return (
        <ErrorPage
            className="server-page"
            image={image}
            title={title}
            header={header}
            info={info}
            buttonText={buttonText}
        />
    )
}

export default ServerPage;